// extracted by mini-css-extract-plugin
export var externalLink = "_7v-0";
export var internalLinkLabel = "_7v-1";